import { canUseWindow } from '../../../common/xenv';

export const getMobileDeviceSpec = () => {
  if (!canUseWindow) {
    return undefined;
  }

  const isOnMobileDevice = /Mobi/i.test(window.navigator.userAgent) || false;

  if (!isOnMobileDevice) {
    return undefined;
  }

  const isAndroid = window.navigator.userAgent.match(/Android/i);
  const isIOS = window.navigator.userAgent.match(/iPhone|iPad|iPod/i);

  return {
    isAndroid,
    isIOS,
  };
};
